module.exports = __webpack_public_path__ + "static/media/cancel.64398169.svg";